// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"743":"b17744bc","6244":"ce6b8f44"}[chunkId] + ".chunk.css";
};